import { configureStore } from "@reduxjs/toolkit";
import rootReducer from ".";

const store = configureStore({
  reducer: rootReducer,

  // Redux DevTools (solo en desarrollo)
  devTools: process.env.NODE_ENV !== "production",

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
